import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-droplet-sharp-solid",
  "use": "icon-droplet-sharp-solid-usage",
  "viewBox": "0 0 384 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\" id=\"icon-droplet-sharp-solid\"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path fill=\"currentColor\" d=\"M192 512c106 0 192-86 192-192S192 0 192 0S0 214 0 320S86 512 192 512zM96 336c0 44.2 35.8 80 80 80h16v32H176c-61.9 0-112-50.1-112-112V320H96v16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol